import {
  useAssignSetting,
  useSetting,
} from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { ENABLE_RECORD_SEARCH_QUERY_ON_SEPARATE_API_250319 } from "@faire/web-api--source/indigofair/settings/ENABLE_RECORD_SEARCH_QUERY_ON_SEPARATE_API_250319";
import { useEffect } from "react";

export const useSettingAndAssignRecordSearchQuery = () => {
  const assignSetting = useAssignSetting(
    ENABLE_RECORD_SEARCH_QUERY_ON_SEPARATE_API_250319
  );
  useEffect(() => {
    assignSetting();
  }, [assignSetting]);

  return useSetting(ENABLE_RECORD_SEARCH_QUERY_ON_SEPARATE_API_250319, false);
};
